import InstanceAxios from './InstanceAxios';

export default class ApiClient {
    constructor() {
        this.get = InstanceAxios.get;
        this.post = InstanceAxios.post;
        this.put = InstanceAxios.put;
        this.delete = InstanceAxios.delete;
    }
}
